'use strict';

const tagManagement = require('../modules/utils/tag_management.utils');
const shellLoadingUtils = require('../modules/utils/shell_loading.utils');
const {sncfShell: frontendShell} = require('@edreamsodigeo/frontend-shell');

const page = 'sncf_payment_page';

Odigeo.Router.handlers.sncf_payment_page = (params) => {
    const $page = $('#page');
    const {type} = Odigeo.Utils.parseHashParameters(params.replace(/^\?/, ''));

    $.extend(true, Odigeo.Router.eventController,
        Odigeo.Router.handlers.frontendShellEventController,
        Odigeo.Router.handlers.globalEventController,
        {
            // Global events will remain bound in any part of the application
            globalEvents: {},
            // View or local events which are triggered from this view.
            // They will be unbinded when the view changes.
            viewEvents: _.extend({}, {
                'frontend-shell:onContinue': 'onContinue',
            }),
            // implementation of events handlers
            eventHandlers: _.extend({}, {
                onContinue() {
                    Odigeo.Router.navigate('#sncf/fare-selection', {params: `?type=${type}`});
                },
            }),
        }
    );

    $('.od-header.header').addClass('odf-hidden');

    Odigeo.Router.eventController.execute();

    $page.removeClass().addClass(page);

    // On page refresh the initial route fires before ViewSwitcher.start(), so its
    // routeHandler hasn't bound yet and the home view retains the 'active' class
    // from the JSP. We manually prime ViewSwitcher here so it picks up the correct
    // active page and the home view is hidden.
    const isDirectLinkLoad = !Odigeo.ViewSwitcher.activePage;
    if (isDirectLinkLoad) {
        $('.od_page').not('#' + page).filter('.active').removeClass('active');
        Odigeo.ViewSwitcher.activePage = $('#' + page).addClass('active');
        shellLoadingUtils.hideDirectLinkWaitingPage($('.waiting_page'), 'sncf_payment_container');
    }

    frontendShell.execute(({page: shellPage}) => {
        shellPage.navigate(page, {});
    });

    tagManagement.updateDatalayer();

    Odigeo.Session.set('page', page);
};
